module.exports = __webpack_public_path__ + "static/img/fareBg.7fd719fc.png";